export const TYPES = {
  SET_BAILIFF_DIALOG_URL_AUDIO: "bailiff_dialog/SET_BAILIFF_DIALOG_URL_AUDIO",
  SET_BAILIFF_DIALOG_SECOND: "bailiff_dialog/SET_BAILIFF_DIALOG_SECOND",
  SET_BAILIFF_DIALOG_PLAY: "bailiff_dialog/SET_BAILIFF_DIALOG_PLAY",
  SET_BAILIFF_DIALOG_SLOT: "bailiff_dialog/SET_BAILIFF_DIALOG_SLOT",
  SET_BAILIFF_DIALOG_KICK: "bailiff_dialog/SET_BAILIFF_DIALOG_KICK",
  //
  SET_BAILIFF_DIALOG_OPTION_SPEAKER:
    "bailiff_dialog/SET_BAILIFF_DIALOG_OPTION_SPEAKER",
};
